import { Trilha } from "./style";
import Img from "../../../../assets/img-trilha.webp";

function TrilhaComponent() {
  return (
    <Trilha>
      <div id="div-pather">
        <div id="div-one">
          <h1>Assista à Trilha do Conhecimento!</h1>
          <p>
            Assistindo, você vai ver como cheguei a esse formato, e também verá
            as contribuições de grandes especialistas, de diferentes áreas,
            mostrando como o mercado precisa de profissionais que se comuniquem
            em inglês.
          </p>
          <a target="blank" href="https://youtube.com/playlist?list=PLr46PD_N9L1jjW5jo-iuucR8-KVA_Y6lP&si=2UiXGchQ85jqFNWx">Assistir agora</a>
        </div>
        <div id="div-two">
          <figure>
            <img src={Img} alt="" />
          </figure>
        </div>
      </div>
    </Trilha>
  );
}

export default TrilhaComponent;
